export enum TimeField {
  departure = 'departure',
  arrival = 'arrival'
}
